export const HTML_CODE_SKELETON = [{
  name: 'BaseHtmlCode', type: 'div'
}]
